import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import FieldTextArea from "../../../CustomComponents/FieldText";
import ReactSelect from "react-select";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../../Firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { getSkills } from "../../../../redux/categary/action";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";
import { useFileValidator } from "../../../../hooks/useFileValidator";
import UploadLoader from "../../../Common/Loader/UploadLoader";

const bxpDatatomap = [
  { title: "Service Title", name: "title", placeholder: "Enter Title" },
  {
    title: "Service cover",
    name: "cover",
    placeholder: "Drag and drop or Browse file",
  },
  { title: "Category", name: "category_id", placeholder: "Select Category" },
  { title: "Description", name: "description", placeholder: "Type here" },
  {
    title: "Project duration",
    name: "duration_type",
    placeholder: "Project duration",
  },
  {
    title: "No of day",
    name: "duration",
    placeholder: "Enter No of day required",
  },
  {
    title: "Requirements",
    name: "requirements",
    placeholder: "Project Requirements if any",
  },
];

const BXPDetails = ({ bxpData, setbxpData, setActiveTab }) => {
  const [image, setImage] = useState(null);
  const [selectCategory, setSelectCategory] = useState(null);
  const dispatch = useDispatch();
  const { validating, validateFiles } = useFileValidator();

  const initialValues = {
    title: bxpData?.title || "",
    cover: bxpData?.cover || "",
    category_id: bxpData?.category_id || "",
    description: bxpData?.description || "",
    duration_type: bxpData?.duration_type || "1", // Default to '1' (Hour) if not provided
    duration: bxpData?.duration || "",
    requirements: bxpData?.requirements || "",
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation,
    cover: Yup.string().required("Cover image is required"),
    category_id: Yup.string().required("Category is required"),
    description: descriptionvalidation,
    duration_type: Yup.string().required("Project duration type is required"),
    duration: Yup.number()
      .required("Duration is required")
      .positive()
      .integer(),
    requirements: Yup.string(),
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleSubmit = async (values) => {
    if (image) {
      const imageRef = ref(getStorage(fireStore), `/Category/${image.name}`);
      const uploadTask = uploadBytesResumable(imageRef, image);
      try {
        await uploadTask;
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        const updatedData = { ...values, cover: url };

        setbxpData(updatedData);
        setActiveTab("WorkSamples");
      } catch (error) {
        urtoast(error.message, 2);
      }
    } else {
      setbxpData(values);
      setActiveTab("WorkSamples");
    }
  };
  useEffect(() => {
    dispatch(getSkills());
  }, []);

  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);

  const skills = useSelector((state) => state.categary.skilllist); // Adjust according to your actual state structure

  useEffect(() => {
    if (bxpData?.category_id && skills) {
      const selectedCategory =
        Array.isArray(skills) &&
        skills.find((skill) => skill.id === bxpData?.category_id);
      if (selectedCategory) {
        setSelectCategory({
          value: selectedCategory.id,
          label: selectedCategory.title,
        });
      }
    }
  }, [bxpData?.category_id, skills]);

  const handleCategoryChange = (selectedOption, formik) => {
    setSelectCategory(selectedOption);
    formik.setFieldValue("category_id", selectedOption.value);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                if (prop.name == "cover") {
                  return (
                    <div key={key} className="form-group position-relative">
                      {validating && <UploadLoader />}
                      <label>{prop.title}</label>
                      <div className="borderstylex">
                        <input
                          onChange={async ({ target }) => {
                            const files = Array.from(target.files);
                            const isValid = await validateFiles(files);
                            if (!isValid) {
                              target.value = "";
                              return;
                            }
                            setImage(target.files[0]);
                            formik.setFieldValue("cover", target.files[0]);
                          }}
                          type="file"
                          style={{ display: "none" }}
                          id="image"
                          name="image"
                        />
                        <label htmlFor="image">
                          Drag and drop or <span>Browse file</span>
                        </label>
                      </div>
                      {formik.values.cover ? (
                        <img
                          className="cv-image"
                          src={
                            image
                              ? URL.createObjectURL(image)
                              : formik.values.cover
                          }
                          alt="Cover"
                        />
                      ) : image ? (
                        <img
                          className="cv-image"
                          src={URL.createObjectURL(image)}
                          alt="Cover"
                        />
                      ) : null}
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                if (prop.name == "duration_type") {
                  return (
                    <div key={key} className="form-group">
                      <label>{prop.title}</label>
                      <div className="label-check">
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="1" />
                          <span className="checkmark">Hour</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="2" />
                          <span className="checkmark">Days</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="3" />
                          <span className="checkmark">Weeks</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="4" />
                          <span className="checkmark">Month</span>
                        </label>
                      </div>
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                if (
                  prop.name == "description" ||
                  prop.name == "requirements"
                ) {
                  return (
                    <FieldTextArea
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                }
                if (prop.name == "category_id") {
                  return (
                    <div className="form-group" key={key}>
                      <label>{prop.title}</label>
                      <ReactSelect
                        options={
                          Array.isArray(skills) &&
                          skills.map((skill) => ({
                            value: skill.id,
                            label: skill.title,
                          }))
                        }
                        placeholder={prop.placeholder}
                        value={selectCategory}
                        onChange={(options) =>
                          handleCategoryChange(options, formik)
                        }
                      />
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                return (
                  <FieldInput
                    title={prop.title}
                    name={prop.name}
                    placeholder={prop.placeholder}
                    key={key}
                  />
                );
              })}
              <div className="button-container">
                <button className="next-button w-100" type="submit">
                  Next
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BXPDetails;
